import axios from "axios";
import {Method, RequestConfig} from "@models/axios";


export const BASE_URL = config.base_url;

/**
 * IIFE
 */
export default (function () {
  const requestConfig: RequestConfig = {
    baseURL: BASE_URL,
    method: Method.GET,
    headers: {
      'Content-Type': 'application/json',
      "Accept": 'text/plain'
    },
    maxRedirects: 0,
    timeout: 0
    // withCredentials: true //to handle session by cookie
  };

  let instance = axios.create(requestConfig);

  // Set the AUTH token for any request
  instance.interceptors.request.use(function (config) {
    const user = JSON.parse(localStorage.getItem('user'));

    if(user && user.access_token){
      config.headers["Authorization"] = `bearer ${user.access_token}`;
    }

    config.params = Object.assign({}, config.params || {});
    return config;
  });

  instance.interceptors.response.use((response) => {
    // do something with the response data
    return response.data;
  }, error => {
    // handle the response error
    if(error.response.status === 401 ){
      window.location.hash = '#/login'
    }
    return Promise.reject(error.response);
  });


  return {
    get: (url: string, options: Object = {}) => instance.get(url, {...requestConfig, ...options}),
    post: (url: string, data: any, options = {}) => instance.post(url, data, {...requestConfig, ...options}),
    put: (url: string, data: any, options = {}) => instance.put(url, data, {...requestConfig, ...options}),
    patch: (url: string, data: any, options = {}) => instance.patch(url, data, {...requestConfig, ...options}),
    delete: (url: string, options = {}) => instance.delete(url, {...requestConfig, ...options}),
  };
})();
